export default __webpack_public_path__ + "static/media/Skranji-Regular.492ba557.ttf";